import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './shared/librerias/material/material.module';
import { AppComponent } from './app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { AuthGuard } from './shared/seguridad/guards';
import { LoaderService } from './shared/seguridad/guards/loader.service';
import { SharedCampusModule } from './shared/services/campus/shared-campus.modules';
import { LoaderInterceptor } from './shared/seguridad/interceptors/loader.interceptor';
import { LoadingModule } from './shared/modules/loading/loading.module';
import { SharedSeguridadModule } from './shared/services/seguridad/shared-seguridad/shared-seguridad.modules';
import { AuthService } from './shared/services/token/auth.service';
import { TokenStorage } from './shared/services/token/token.storage';
import { SharedUploadModule } from './shared/services/upload/shared-upload/shared-upload.module';
import { StoreModule } from '@ngrx/store';
import { uiReducer } from './store/ui/reducer';
import { ConfirmacionObservacionModule } from './shared/modules/confirmacion-observacion/confirmacion-observacion.module';
import { SharedEvaluacionModule } from './shared/services/evaluacion/shared-evaluacion/shared-evaluacion.module';
import { SharedTitulacionModule } from './shared/services/titulacion/shared-titulacion/shared-titulacion.module';
import { ConfirmacionAprobacionModule } from './shared/modules/confirmacion-aprobacion/confirmacion-aprobacion.module';
import { BuscarPersonasModule } from './shared/modules/buscar-persona-module';
import { SharedIdiomasModule } from './shared/services/idiomas/shared-idiomas.module';
import { SeleccionPeriodoAcademicoModule } from './shared/modules/seleccion-periodo-academico/seleccion-periodo-academico.module';
import { UploadModule } from './shared/modules/upload/upload.module';
import { SharedBienestarModule } from './shared/services/bienestar/shared-bienestar/shared-bienestar.module';
import { SharedGeneralModule } from './shared/services/general/shared-general/shared-general.module';
import { ConfiguracionSistemaGeneralAppModule } from './layout/modulos/general/configuracionSistemaGeneralApp/configuracionSistemaGeneralApp.module';
import { SharedNotificacionModule } from './shared/services/notificacion/shared-notificacion/shared-notificacion/shared-notificacion.module';
import { SharedPersonaModule } from './shared/services/persona/shared-persona/shared-persona.module';
import { SeleccionPeriodoTitulacionModule } from './shared/modules/seleccion-periodo-titulacion/seleccion-periodo-titulacion.module';
import { RecargarComponenteDirective } from './directive/recargar-componente.directive';
import { SharedAspirantesModule } from './shared/services/aspirante/sharedAspirante/shared.module';
import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { ErrorInterceptor } from './ErrorInterceptor ';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedVinculacionModule } from './shared/services/vinculacion/shared-vinculacion/shared-vinculacion.module';
import { SharedResidenciaModule } from './shared/services/residencia/shared-residencia/shared-residencia.module';
import { BuscarTutorexModule } from './shared/modules/buscar-tutorex-module';
import { MatIconModule } from '@angular/material/icon';
import { SharedVotacionModule } from './shared/services/votacion/shared-votacion/shared-votacion.module';
import { SharedPosgradoModule } from './shared/services/posgrado/shared-posgrado/shared-posgrado.module';

export function createTranslateLoader(http: HttpClient) {

  // for development
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    RecargarComponenteDirective

  ],
  imports: [
    NgxMatColorPickerModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    LoadingModule,
    FormsModule,
    AppRoutingModule,
    ConfirmacionObservacionModule,
    ConfirmacionAprobacionModule,
    SeleccionPeriodoAcademicoModule,
    SeleccionPeriodoTitulacionModule,
    BuscarPersonasModule,
    BuscarTutorexModule,

    MatIconModule,
    UploadModule,
    MatSnackBarModule,

    StoreModule.forRoot({ auth: uiReducer, ui: uiReducer }),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      progressBar: true,
      closeButton: true,
      preventDuplicates: true,
      newestOnTop: true,
      timeOut: 5000,
      extendedTimeOut: 2000,
      tapToDismiss: true,
      // Importante: asegurar que se posicione sobre el viewport
      // target: 'body' // Por defecto ya es body, pero verificar que no se sobreescriba
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      defaultLanguage: 'es'
    }),
    /**INCLUIR SERVICIOS */

    SharedCampusModule.forRoot(),
    SharedSeguridadModule.forRoot(),
    SharedUploadModule.forRoot(),
    SharedEvaluacionModule.forRoot(),
    SharedTitulacionModule.forRoot(),
    SharedIdiomasModule.forRoot(),
    SharedBienestarModule.forRoot(),
    SharedGeneralModule.forRoot(),
    SharedNotificacionModule.forRoot(),
    SharedPersonaModule.forRoot(),
    SharedResidenciaModule.forRoot(),
    SharedAspirantesModule.forRoot(),
    SharedVinculacionModule.forRoot(),
    SharedVotacionModule.forRoot(),
    SharedPosgradoModule.forRoot(),
    BuscarPersonasModule,
    BuscarTutorexModule,
    ConfiguracionSistemaGeneralAppModule
  ],

  providers: [AuthGuard, AuthService, TokenStorage, LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
